import {AppAction} from '../../../appActions';
import {AnalyticsPanelExportsActionsEnum} from './analyticsPanelExportsActions';
import {AnalyticsPanelExportsState} from './analyticsPanelExportsState';

/*
 * Analytics views panel.
 */

export function analyticsPanelExportsReducer(
  state: AnalyticsPanelExportsState,
  action: AppAction,
): AnalyticsPanelExportsState {
  switch (action.type) {
    case AnalyticsPanelExportsActionsEnum.FETCH_COLUMN_NAMES:
      return {
        ...state,
        isFetchingColumnNames: true,
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_COLUMN_NAMES_COMPLETED:
      return {
        ...state,
        isFetchingColumnNames: false,
        columnNames: action.payload,
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_COLUMN_NAMES_FAILED:
      return {
        ...state,
        isFetchingColumnNames: false,
        columnNames: {messages: [], activities: [], csat: []},
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_EVENT_TYPES:
      return {
        ...state,
        isFetchingEventTypes: true,
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_EVENT_TYPES_COMPLETED:
      return {
        ...state,
        isFetchingEventTypes: false,
        eventTypes: action.payload,
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_EVENT_TYPES_FAILED:
      return {
        ...state,
        isFetchingEventTypes: false,
        eventTypes: [],
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_EXPORTS:
      return {
        ...state,
        isFetchingExports: true,
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_EXPORTS_COMPLETED:
      return {
        ...state,
        isFetchingExports: false,
        exports: action.payload,
      };

    case AnalyticsPanelExportsActionsEnum.FETCH_EXPORTS_FAILED:
      return {
        ...state,
        isFetchingExports: false,
        exports: [],
      };

    case AnalyticsPanelExportsActionsEnum.EXPORT_UPDATED_RECEIVED: {
      const exports = [...state.exports];

      const existingImportIndex = exports.findIndex((currentExport) => {
        // If the export includes an id, we can attempt to match it to an existing export by id.
        if (currentExport.id && action.payload.id && currentExport.id === action.payload.id) {
          return currentExport.id === action.payload.id;
        }

        // filename should always be present, so we use it for matching if id is not included in the API.
        return currentExport.filename === action.payload.filename;
      });

      if (existingImportIndex > -1) {
        exports[existingImportIndex] = action.payload;
      } else {
        exports.unshift(action.payload);
      }

      return {
        ...state,
        exports,
      };
    }

    default:
      return state;
  }
}

export function makeAnalyticsPanelExportsState(): AnalyticsPanelExportsState {
  return {
    isFetchingColumnNames: false,
    columnNames: {messages: [], activities: [], csat: []},
    isFetchingEventTypes: false,
    eventTypes: [],
    isFetchingExports: false,
    exports: [],
  };
}
